import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import TerminalsContainer from '../../containers/logistics/Terminals';
import FMPSelect from './FMPSelect';
import FormComponent from '../FormComponent';

const styles = () => {
	return {
		product: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
			fontWeight: 100,
		},
		loading: {
			fontSize: 11,
			lineHeight: '11px',
			color: '#777',
		},
		margin: {
			margin: '5px 0px',
		},
	};
};

class FMPSupplierPicker extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			supplierId: '',
		};
	}

	componentDidMount() {
		const { terminals, searchTerminals } = this.props;

		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	getSupplierOptions = () => {
		const { terminalId, terminals, supplierMap, productTypes } = this.props;
		const supplierOptions = [];

		const selectedTerminal = _.find(terminals, { terminalId });
		if (!selectedTerminal) {
			return supplierOptions;
		}

		const checkProductTypes = !_.isEmpty(_.compact(productTypes));
		const map = {};
		[
			{ type: 'bulk', key: 'bulkSuppliers' },
			{ type: 'station', key: 'supplierProducts' },
		].forEach(({ key }) => {
			if (!selectedTerminal[key]) {
				return;
			}

			selectedTerminal[key].forEach((supplierProduct) => {
				const { supplierId, product } = supplierProduct;
				const supplier = supplierMap[supplierId];

				if (checkProductTypes) {
					if (!_.includes(productTypes, product)) {
						return;
					}
				}

				const key = `${supplierId}`;
				if (map[key]) {
					return;
				}
				map[key] = true;

				const option = {
					display: `${supplier.name}`,
					value: supplierId,
				};
				supplierOptions.push(option);
			});
		});
		return supplierOptions;
	};

	render() {
		const { terminals, value, path, onChange } = this.props;

		if (_.isEmpty(terminals)) {
			return <div>Fetching terminals details...</div>;
		}

		const supplierOptions = this.getSupplierOptions();

		return (
			<FMPSelect
				{...this.setForm('supplierId', 'Supplier')}
				path={path}
				value={value}
				options={_.sortBy(supplierOptions, 'display')}
				onChange={onChange}
			/>
		);
	}
}

FMPSupplierPicker.propTypes = {
	label: PropTypes.string,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,
	supplierMap: PropTypes.object,

	productTypes: PropTypes.array,
	md: PropTypes.number,
	classes: PropTypes.object,
};

export default _.flow([withStyles(styles), TerminalsContainer])(FMPSupplierPicker);

FMPSupplierPicker.defaultProps = {
	md: 12,
};
